import React, { useEffect } from "react";
import { useRecommendation } from "../../context/RecommendationContext";
const AllCommodities = () => {
  const { commodities } = useRecommendation();
  console.log("Commodities", commodities);
  const formatVolume = (volume) => {
    return typeof volume === "string"
      ? Number(volume).toLocaleString()
      : volume.toLocaleString();
  };
  useEffect(() => {
    if (commodities && commodities.length > 0) {
      localStorage.setItem(
        "commodities_context_cache",
        JSON.stringify(commodities)
      );
    }
  }, [commodities]);
  return (
    <div>
      <h2
        style={{
          fontSize: "1.2rem",
          textAlign: "center",
          fontWeight: "600",
          color: "white",
        }}
      >
        All Commodities
      </h2>
      <div className="stock-table-container">
        <div className="market-cards">
          <div className="market-card">
            <div className="market-card-title">
              <h2 className="card-title">ALl Commodities</h2>
              {/* <IoMdTrendingUp style={{ color: "#249966" }} /> */}
            </div>

            {commodities?.map((stock) => (
              <div className="card-row" key={stock?.id}>
                <div className="left">
                  <p className="name">{stock?.product}</p>
                  <p className="price">₹{stock?.last_traded_price}</p>
                </div>

                <div className="right">
                  <p
                    className="change "
                    style={{
                      color: stock?.per_change > 0 ? "#249966" : "#f87171",
                      fontWeight: "bold",
                    }}
                  >
                    {stock?.per_change > 0
                      ? `+${stock?.per_change}`
                      : `${stock?.per_change}`}
                    %
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* <table className="stock-table">
          <thead>
            <tr>
              <th>Product</th>

            
              <th>Price</th>

              
              <th>Close</th>
              <th>% Change</th>
             
              <th>Volume</th>
              <th>Recommendation</th>

         
            </tr>
          </thead>
          <tbody>
            {commodities.map((item) => (
              <tr
                key={item.id}
                className="stock-row"
                
              >
                <td>{item.product}</td>

                
                <td>₹{item.last_traded_price}</td>
             
                <td>{item.close_price}</td>
                <td
                  style={{
                    color: item.per_change >= 0 ? "#2fd18a" : "#f87171",
                    fontWeight: "bold",
                  }}
                >
                  {item.per_change}%
                </td>
                

                <td>{formatVolume(item.total_quantity_traded)}</td>
                <td>
                  <button className="rec-btn">Recommendation</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table> */}
      </div>
    </div>
  );
};

export default AllCommodities;
